import { createAsyncThunk } from "@reduxjs/toolkit";

import { commentsService } from "../../../admin/services/comments-service";
import { Comment } from "../../../patient/components/models/comment";
import { showErrorStatus, showStatus } from "../../../security/state/user-slice";
import { Utils } from "../../../shared/utils";
import { specialistClientService } from "../../services/implementation-client-service";

export const getClients = createAsyncThunk(
  "implementationSpecialistClientContext/getClients",
  async (data: { includeFacility: boolean }, thunkAPI) => {
    const { includeFacility } = data
    const clients = await specialistClientService.getClients(includeFacility);
    // returned 'entity' contains objects for all clients, as well as clients filtered by closed, isActive, Stripe Set Up Incomplete, and more
    if (clients.hasErrors) {
      thunkAPI.dispatch(showErrorStatus(clients.errorMessage));
      throw new Error();
    } else {
      return clients.entity;
    }
  }
);

export const getClientVobs = createAsyncThunk(
    "implementationSpecialistClientContext/getClientVobs",
    async () => {
        const clientVobs =  await specialistClientService.getClientVobs();
        if (clientVobs.hasErrors) {
            throw new Error();
        } else {
            return clientVobs.entity;
        }
    }
);

export const getClient = createAsyncThunk(
  "implementationSpecialistClientContext/getClient",
  async (clientId: number, thunkAPI) => {
    const client = await specialistClientService.getClient(clientId);
    if (client.hasErrors) {
      thunkAPI.dispatch(showErrorStatus(client.errorMessage));
      throw new Error();
    } else {
      return client.entity;
    }
  }
);

export const createClientComment = createAsyncThunk(
  'implementationSpecialistClientContext/createClientComment',
  async (data:{message: string, comment: Comment}, thunkAPI) => {
      const {message, comment} = data
       const response = await commentsService.createClientComment(comment,comment.clientId );

      if (response.hasErrors) {
        thunkAPI.dispatch(showErrorStatus(response.errorMessage))
        throw new Error(response.errorMessage);
      } else {
        thunkAPI.dispatch(showStatus(message));
      }

      return response.entity
    }
);


export const deleteClientComment = createAsyncThunk(
  'implementationSpecialistClientContext/deleteClientComment',
  async (data: {clientId: number, commentId: number}, thunkAPI) =>  {

      const response = await commentsService.deleteClientComment(data.clientId, data.commentId);
      if (response.hasErrors) {
        thunkAPI.dispatch(showErrorStatus(response.errorMessage))
        throw new Error(response.errorMessage);
      }

      return response.entity
  }
);

export const getFacilityReferralSources = createAsyncThunk(
  "implementationSpecialistClientContext/getFacilityReferralSources",
  async (data: {facilityId: number, clientId: number}, thunkAPI) => {
    const response = await specialistClientService.getReferralSources(data.facilityId, data.clientId);
    if (response.hasErrors) {
      Utils.robustErrorHandler(response, thunkAPI);
    } else {
      return response.entity;
    }
  }
);

export const getClientDeficiencyNotification = createAsyncThunk(
  "implementationSpecialistClientContext/getClientDeficiencyNotification",
  async (clientId: number, thunkAPI) => {
    const response = await specialistClientService.getClientDeficiencyNotification(clientId);
    if (response.hasErrors) {
      Utils.robustErrorHandler(response, thunkAPI);
    } else {
      return response.entity;
    }
  }
);


export const getClientRiskAssessmentConfigs = createAsyncThunk(
  'implementationSpecialistClientContext/getClientRiskAssessmentConfigs',
  async (data: 
    {
      clientId: number, 
      facilityId?: number
    }, 
    thunkAPI) => {
    const response = await specialistClientService.getClientRiskAssessmentConfigs(data.clientId, data.facilityId)
    
    if (response.hasErrors) {
      return []// TODO: api shouldn't throw 400 if no records are found
    } else {
      return response.entity;
    }
  }
)


